import React, { useState, useRef, useEffect } from "react";
import "./referencedata.scss";
import ReferenceTabs from "./common/ReferenceTabs";
import SearchBox from "./common/SearchBox";
import TablePagination from "./common/TablePagination";
import AbbreviationsTab from "./tabs/AbbreviationsTab";
import { useNavigate } from "react-router-dom";
import {
  importAbbreviations,
  importAlias,
  importAnglicized,
  importBadData,
  importSingleDouble,
  importInitials,
  importNickNames,
  importIntervening,
  getAllActiveAbbreviations,
  getAllActiveAlias,
  getAllActiveAnglicized,
  getAllActiveInitials,
  getAllActiveNicknames,
  getAllActiveBadData,
  getAllActiveSingleDouble,
  getAllActiveInterveningData,
  importCountriesData,
  getAllActiveCountries,
  deleteSingledouble,
  deleteNickname,
  baseUrl,
} from "../../Api";
import { deleteMultipleReferenceData } from "../../Api";
import AliasesTab from "./tabs/AliasesTab";
import AnglicizedTab from "./tabs/AnglicizedTab";
import InitialsTab from "./tabs/InitialsTab";
import NicknamesTab from "./tabs/NicknamesTab";
import BadDataTab from "./tabs/BadDataTab";
import DoubleLettersTab from "./tabs/DoubleLettersTab";
import InterveningTab from "./tabs/InterveningTab";
import MT202Tab from "./tabs/MT202Tab";
import ViewHistoryModal from "./common/ViewHistoryModal";
import CreateModal from "./common/CreateModal";
import EditModal from "./common/EditModal";
import Swal from "sweetalert2";
import CountriesTab from "./tabs/CountriesTab";
import {
  MdCloudUpload,
  MdDelete,
  MdCreateNewFolder,
  MdCloudDownload,
} from "react-icons/md";
import {
  deleteAbbreviation,
  deleteAlias,
  deleteAnglicized,
  deleteBadData,
  deleteInitial,
  deleteIntervening,
  deleteCountry,
} from "../../Api";

// Tab data
const tabsData = [
  "Abbreviations",
  "Aliases",
  "Anglicized",
  "Bad Data",
  "Double letters",
  "Initial",
  "Nick Name",
  "Intervening",
  "Countries",
  "MT202",
];

// defining specific fields for each tab to perform complete search
const searchFields = {
  0: ["abbreviations", "name"], // Abbreviations
  1: ["name", "alias_word"], // Aliases
  2: ["entity_name", "anglicized_word"], // Anglicized
  3: ["special_char"], // Bad data
  4: ["letter", "replace_letter"], // Double letters
  5: ["name", "initial"], // Initials
  6: ["name", "nick_name"], // Nicknames
  7: ["word_list"], // Intervening words
  8: ["country"], // Countries
};

function ReferenceData() {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({
    record_id: "",
    name: "",
    abbreviations: "",
    alias_word: "",
    anglicized_name: "",
    description: "",
    letter: "",
    replace_letter: "",
    initial: "",
    nickname: "",
    intervening: "",
    word_list: "",
    special_char: "",
    country: "",
    correl_id: "",
    is_active: "Y",
    bank_code: localStorage.getItem("bank_code") || "",
  });

  const [createFormData, setCreateFormData] = useState({
    name: "",
    abbreviations: "",
    alias_word: "",
    anglicized_name: "",
    description: "",
    letter: "",
    replace_letter: "",
    initial: "",
    nickname: "",
    intervening: "",
    word_list: "",
    special_char: "",
    country: "",
    correl_id: localStorage.getItem("correl_id") || "",
    is_active: "Y",
    bank_code: localStorage.getItem("bank_code") || "",
  });
  const resetCreateForm = () => {
    setCreateFormData({
      name: "",
      abbreviations: "",
      alias_word: "",
      anglicized_name: "",
      description: "",
      letter: "",
      replace_letter: "",
      initial: "",
      nickname: "",
      intervening: "",
      word_list: "",
      special_char: "",
      country: "",
      correl_id: localStorage.getItem("correl_id") || "",
      is_active: "Y",
      bank_code: localStorage.getItem("bank_code") || "",
    });
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [summaryModal, setSummaryModal] = useState(false);
  const fileInputRef = useRef(null);
  const [modalCurrentPage, setModalCurrentPage] = useState(1);

  const [abbreviations, setAbbreviations] = useState([]);
  const [aliases, setAliases] = useState([]);
  const [anglicized, setAnglicized] = useState([]);
  const [badData, setBadData] = useState([]);
  const [doubleLetters, setDoubleLetters] = useState([]);
  const [initials, setInitials] = useState([]);
  const [nicknames, setNicknames] = useState([]);
  const [intervining, setIntervining] = useState([]);
  const [countries, setCountries] = useState([]);
  // store selections per-tab so each tab's delete button and selection is isolated
  const [selectedRowsByTab, setSelectedRowsByTab] = useState({});

  const getSelectedRowsForTab = (tabIndex) =>
    Array.isArray(selectedRowsByTab?.[tabIndex])
      ? selectedRowsByTab[tabIndex]
      : [];

  const setSelectedRowsForTab = (tabIndex, valueOrUpdater) => {
    setSelectedRowsByTab((prev) => {
      const prevArr = Array.isArray(prev?.[tabIndex]) ? prev[tabIndex] : [];
      const newArr =
        typeof valueOrUpdater === "function"
          ? valueOrUpdater(prevArr)
          : valueOrUpdater;
      return { ...prev, [tabIndex]: newArr };
    });
  };

  const deleteFunctions = {
    0: deleteAbbreviation,
    1: deleteAlias,
    2: deleteAnglicized,
    3: deleteBadData,
    4: deleteSingledouble,
    5: deleteInitial,
    6: deleteNickname,
    7: deleteIntervening,
    8: deleteCountry,
  };

  useEffect(() => {
    fetchTabData();
  }, [selectedTab]);

  const fetchTabData = async () => {
    try {
      console.log("Fetching data for tab:", selectedTab);
      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
      });

      let response;
      switch (selectedTab) {
        case 0: // Abbreviations
          console.log("Calling getAllActiveAbbreviations");
          response = await getAllActiveAbbreviations();
          console.log("Abbreviations response:", response);
          if (response.status === "S" && response.result_code === 200) {
            setAbbreviations(response.result_info || []);
            console.log("Set abbreviations:", response.result_info);
          } else if (response.status === "E") {
            Swal.fire({
              icon: "warning",
              text:
                response.message ||
                "An error occurred while fetching abbreviations.",
              showConfirmButton: false,
              timer: 3000,
            });
          }
          break;
        case 1: // Aliases
          console.log("Calling getAllActiveAlias");
          response = await getAllActiveAlias();
          console.log("Aliases response:", response);
          if (response.status === "S" && response.result_code === 200) {
            setAliases(response.result_info || []);
            console.log("Set aliases:", response.result_info);
          } else if (response.status === "E") {
            Swal.fire({
              icon: "warning",
              text:
                response.message || "An error occurred while fetching aliases.",
              showConfirmButton: false,
              timer: 3000,
            });
          }
          break;
        case 2: // Anglicized
          response = await getAllActiveAnglicized();
          if (response.status === "S" && response.result_code === 200) {
            setAnglicized(response.result_info || []);
          } else if (response.status === "E") {
            Swal.fire({
              icon: "warning",
              text:
                response.message ||
                "An error occurred while fetching anglicized data.",
              showConfirmButton: false,
              timer: 3000,
            });
          }
          break;
        case 3: // Bad Data
          response = await getAllActiveBadData();
          if (response.status === "S" && response.result_code === 200) {
            setBadData(response.result_info || []);
          } else if (response.status === "E") {
            Swal.fire({
              icon: "warning",
              text:
                response.message ||
                "An error occurred while fetching bad data.",
              showConfirmButton: false,
              timer: 3000,
            });
          }
          break;
        case 4: // Double letters
          response = await getAllActiveSingleDouble();
          if (response.status === "S" && response.result_code === 200) {
            setDoubleLetters(response.result_info || []);
          } else if (response.status === "E") {
            Swal.fire({
              icon: "warning",
              text:
                response.message ||
                "An error occurred while fetching double letters data.",
              showConfirmButton: false,
              timer: 3000,
            });
          }
          break;
        case 5: // Initials
          response = await getAllActiveInitials();
          if (response.status === "S" && response.result_code === 200) {
            setInitials(response.result_info || []);
          } else if (response.status === "E") {
            Swal.fire({
              icon: "warning",
              text:
                response.message ||
                "An error occurred while fetching initials data.",
              showConfirmButton: false,
              timer: 3000,
            });
          }
          break;
        case 6: // Nicknames
          response = await getAllActiveNicknames();
          if (response.status === "S" && response.result_code === 200) {
            setNicknames(response.result_info || []);
          } else if (response.status === "E") {
            Swal.fire({
              icon: "warning",
              text:
                response.message ||
                "An error occurred while fetching nicknames data.",
              showConfirmButton: false,
              timer: 3000,
            });
          }
          break;
        case 7: // Intervening
          response = await getAllActiveInterveningData();
          if (response.status === "S" && response.result_code === 200) {
            setIntervining(response.result_info || []);
          } else if (response.status === "E") {
            Swal.fire({
              icon: "warning",
              text:
                response.message ||
                "An error occurred while fetching intervening data.",
              showConfirmButton: false,
              timer: 3000,
            });
          }
          break;
        case 8: // Countries
          response = await getAllActiveCountries();
          if (response.status === "S" && response.result_code === 200) {
            setCountries(response.result_info || []);
          } else if (response.status === "E") {
            Swal.fire({
              icon: "warning",
              text:
                response.message ||
                "An error occurred while fetching countries data.",
              showConfirmButton: false,
              timer: 3000,
            });
          }
          break;
        default:
          break;
      }
      Swal.close();
      if (
        response.status === "F" &&
        response.message === "Unauthorized - Missing token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      }
      if (
        response.status === "F" &&
        response.message === "Unauthorized - Invalid token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.close();
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setCurrentPage(1);
    setSearchTerm("");
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  // Modal and button handlers
  const handleSummaryModal = () => setSummaryModal(!summaryModal);
  const handleCreateClick = () => setCreateModalOpen(true);

  // Update handleDeleteClick to refresh data for all tabs
  const handleDeleteClick = () => {
    fetchTabData();
  };

  // Create Modal handlers
  const handleCreateFormChange = (e) => {
    const { name, value } = e.target;
    setCreateFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateSubmit = () => {
    fetchTabData();
    setCreateModalOpen(false);
  };

  const handleEditSubmit = () => {
    // Fetch data for the current tab after edit
    fetchTabData();
    setEditModalOpen(false);
  };

  const handleBulkDelete = async () => {
    const selectedRows = getSelectedRowsForTab(selectedTab);
    if (!Array.isArray(selectedRows) || selectedRows.length === 0) return;

    const result = await Swal.fire({
      text: `Delete ${selectedRows.length} selected record(s)?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });

    if (!result.isConfirmed) return;

    Swal.fire({
      html: `<img src=${require("../../assets/loader.gif")} style="width: 50px">`,
      showConfirmButton: false,
      allowOutsideClick: false,
    });

    try {
      // Build data_type based on selected tab
      const tabToType = {
        0: "abbreviations",
        1: "aliases",
        2: "anglicized",
        3: "baddata",
        4: "doubleletters",
        5: "initial",
        6: "nickname",
        7: "intervening",
        8: "countries",
      };

      const data_type = tabToType[selectedTab];

      if (!data_type) {
        Swal.close();
        Swal.fire({
          text: "Delete not supported for this tab.",
          icon: "error",
          timer: 3000,
        });
        return;
      }

      // Determine if user has effectively selected all records of this tab
      let allIdsForTab = [];
      switch (selectedTab) {
        case 0:
          allIdsForTab = abbreviations.map((r) => r.record_id);
          break;
        case 1:
          allIdsForTab = aliases.map((r) => r.record_id);
          break;
        case 2:
          allIdsForTab = anglicized.map((r) => r.record_id);
          break;
        case 3:
          allIdsForTab = badData.map((r) => r.record_id);
          break;
        case 4:
          allIdsForTab = doubleLetters.map((r) => r.record_id);
          break;
        case 5:
          allIdsForTab = initials.map((r) => r.record_id);
          break;
        case 6:
          allIdsForTab = nicknames.map((r) => r.record_id);
          break;
        case 7:
          allIdsForTab = intervining.map((r) => r.record_id);
          break;
        case 8:
          allIdsForTab = countries.map((r) => r.record_id);
          break;
        default:
          allIdsForTab = [];
      }

      const selectedRowsForTab = getSelectedRowsForTab(selectedTab);

      const payload = {
        data_type,
        record_ids: selectedRowsForTab,
        correl_id: localStorage.getItem("correl_id") || "",
      };

      const apiData = await deleteMultipleReferenceData(payload);

      Swal.close();

      if (apiData.status === "S" && apiData.result_code === 200) {
        Swal.fire({
          text: "Selected records deleted successfully.",
          icon: "success",
          timer: 2500,
          showConfirmButton: false,
        });
        // clear selection for the current tab only
        setSelectedRowsForTab(selectedTab, []);
        fetchTabData();
        return;
      }

      // handle auth errors
      if (
        apiData.status === "F" &&
        (apiData.message === "Unauthorized - Missing token" ||
          apiData.message === "Unauthorized - Invalid token")
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
        return;
      }

      Swal.fire({
        text: apiData.message || "Failed to delete selected records.",
        icon: "warning",
        timer: 3000,
      });
    } catch (err) {
      console.error(err);
      Swal.close();
      Swal.fire({
        text: "Error deleting selected records.",
        icon: "error",
        timer: 3000,
      });
    }
  };

  const submit = async (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      Swal.fire({
        text: "Please select a file to upload",
        icon: "warning",
        showConfirmButton: true,
        heightAuto: false,
      });
      return;
    }
    const validFileNameRegex = /^[a-zA-Z0-9_.-]+$/;
    if (!validFileNameRegex.test(file.name)) {
      Swal.fire({
        text: "File name can only contain letters, numbers, underscores (_), hyphens (-), and dots (.). Spaces and other special characters are not allowed.",
        icon: "warning",
        showConfirmButton: true,
        heightAuto: false,
      });
      return;
    }
    if (file) {
      // Validate file name based on selected tab
      const fileName = file.name;
      const datePattern = "\\d{6}"; // DDMMYY
      // const datePattern = "(\\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01])";
      // const datePattern = "^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])(\\d{2})$";

      const filePatterns = {
        0: `^Abbreviations_${datePattern}\\.csv$`,
        1: `^NameAliases_${datePattern}\\.csv$`,
        2: `^AnglicizedWords_${datePattern}\\.csv$`,
        3: `^BadData_${datePattern}\\.csv$`,
        4: `^DoubleLetters_${datePattern}\\.csv$`,
        5: `^Initials_${datePattern}\\.csv$`,
        6: `^NickName_${datePattern}\\.csv$`,
        7: `^InterveningWords_${datePattern}\\.csv$`,
        8: `^Countries_${datePattern}\\.csv$`,
        9: `^MT202_${datePattern}\\.csv$`,
      };

      const expectedPattern = filePatterns[selectedTab];
      if (
        !expectedPattern ||
        !new RegExp(expectedPattern, "i").test(fileName)
      ) {
        const tabNames = {
          0: "Abbreviations_DDMMYY.csv",
          1: "NameAliases_DDMMYY.csv",
          2: "AnglicizedWords_DDMMYY.csv",
          3: "BadData_DDMMYY.csv",
          4: "DoubleLetters_DDMMYY.csv",
          5: "Initials_DDMMYY.csv",
          6: "NickName_DDMMYY.csv",
          7: "InterveningWords_DDMMYY.csv",
          8: "Countries_DDMMYY.csv",
          9: "MT202_DDMMYY.csv",
        };

        Swal.fire({
          title: "Invalid File Name",
          text: `File name must follow the format: ${tabNames[selectedTab]}`,
          icon: "warning",
          showConfirmButton: true,
          heightAuto: false,
        });
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("bank_code", localStorage.getItem("bank_code") || "");
      formData.append("correl_id", localStorage.getItem("correl_id") || "");

      try {
        let response;

        Swal.fire({
          html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
          showConfirmButton: false,
          heightAuto: false,
          customClass: { popup: "loader-swal" },
          allowOutsideClick: false,
        });

        const allowableFormats = [".csv"];
        const extension = file.name
          .slice(file.name.lastIndexOf("."))
          .toLowerCase();

        if (!allowableFormats.includes(extension)) {
          Swal.fire({
            text:
              "Please upload a file in the following format: " +
              allowableFormats.join(", "),
            icon: "warning",
            showConfirmButton: false,
            allowOutsideClick: false,
            heightAuto: false,
            timer: 3000,
          });
          return;
        }

        switch (selectedTab) {
          case 0:
            response = await importAbbreviations(formData);
            break;
          case 1:
            response = await importAlias(formData);
            break;
          case 2:
            response = await importAnglicized(formData);
            break;
          case 3:
            response = await importBadData(formData);
            break;
          case 4:
            response = await importSingleDouble(formData);
            break;
          case 5:
            response = await importInitials(formData);
            break;
          case 6:
            response = await importNickNames(formData);
            break;
          case 7:
            response = await importIntervening(formData);
            break;
          case 8: // Countries
            response = await importCountriesData(formData);
            break;
          default:
            break;
        }

        Swal.close();
        if (response?.status === "S") {
          Swal.fire({
            html: `<p style="font-weight:bold">File uploaded successfully!</p>
             <p>${response?.message || ""}</p>`,
            icon: "success",
            showConfirmButton: "Ok",
            heightAuto: false,
          }).then(() => {
            fetchTabData();
          });
        }
        // handle blank values case
        else if (response?.result_code === 402) {
          Swal.fire({
            text: "No data found in the file. Please check file content.",
            icon: "warning",
            showConfirmButton: true,
            heightAuto: false,
          });
        } else if (
          response?.result_code === 400 ||
          response?.result_code === 409 || response?.result_code === 422
        ) {
          Swal.fire({
            icon: "warning",
            showConfirmButton: true,
            heightAuto: false,
            html: `
                  <p style="margin-bottom: 8px;">
                    ${
                      response?.message ||
                      "Invalid File name. Please check file name."
                    }
                  </p>
                 ${
                   response?.log_file &&
                   `<a href="${baseUrl + "/files/logs/" + response.log_file}" 
                     target="_blank" 
                     style="color:#3366ff; text-decoration: underline;" download="${
                       response.log_file
                     }">
                    Download Log File
                  </a>`
                 }
             `,
          });
        } else if (response?.result_code === 405) {
          Swal.fire({
            text:
              response?.message ||
              "Header is missing or incorrect. Please check the file header.",
            icon: "warning",
            showConfirmButton: true,
            heightAuto: false,
          });
        }
        // handle file already exists case
        // else if (response?.result_code === 409) {
        //   Swal.fire({
        //     text: response?.message,
        //     icon: "warning",
        //     showConfirmButton: true,
        //     heightAuto: false,
        //   });
        // }
        else if (response?.status === "E") {
          Swal.fire({
            icon: "error",
            text:
              response.message || "An error occurred while uploading the file.",
            showConfirmButton: true,
            heightAuto: false,
          });
        } else if (response?.status === "F") {
          if (
            response.message === "Unauthorized - Missing token" ||
            response.message === "Unauthorized - Invalid token"
          ) {
            Swal.fire({
              text: "Please login with your credentials",
              icon: "warning",
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              localStorage.clear();
              navigate("/login");
            });
          }
        } else {
          Swal.fire({
            text: response?.message || "Error uploading file",
            icon: "warning",
            showConfirmButton: false,
            heightAuto: false,
            timer: 1500,
          });
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        Swal.close();
        Swal.fire({
          text: "An error occurred while uploading the file",
          icon: "error",
          showConfirmButton: false,
          timer: 3000,
        });
      }
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  // exact search function
  const exactMatchFilter = (row, tabIndex, term) => {
    if (!term.trim()) return true;
    const fields = searchFields[tabIndex];
    const normalizedSearch = term.trim().toLowerCase();

    return fields.some((field) => {
      const value = row[field];
      if (!value) return false;

      const normalizedValue = value.toString().trim().toLowerCase();
      return normalizedValue === normalizedSearch;
    });
  };

  // partial search function
  const partialMatchFilter = (row, tabIndex, term) => {
    if (!term.trim()) return true;

    const fields = searchFields[tabIndex];
    const normalizedSearch = term.trim().toLowerCase();

    return fields.some((field) => {
      const value = row[field];
      if (!value) return false;

      const normalizedValue = value.toString().trim().toLowerCase();
      return normalizedValue.includes(normalizedSearch);
    });
  };

  // helper to return filtered array for a given tabIndex
  const filteredData = (tabIndex, dataArr) => {
    if (!Array.isArray(dataArr)) return [];
    // if searchTerm empty -> return original data
    if (!searchTerm || !searchTerm.trim()) return dataArr;
    // if (tabIndex === 8) {
    //   return dataArr.filter((item) =>
    //     partialMatchFilter(item, tabIndex, searchTerm)
    //   );
    //   //  countries.filter((item) =>
    //   //                   item.country?.toLowerCase().includes(searchTerm)
    //   //                 ).length / itemsPerPage
    //   //               : 1
    // }
    return dataArr.filter((item) =>
      exactMatchFilter(item, tabIndex, searchTerm)
    );
  };

  const handleExportData = async () => {
    try {
      // Show loading indicator
      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        text: "Exporting data...",
        showConfirmButton: false,
        heightAuto: false,
        allowOutsideClick: false,
        customClass: { popup: "loader-swal" },
      });

      // Helper function to escape CSV values
      const csvEscape = (value) => {
        if (value === null || value === undefined) return "";
        const s = String(value);
        return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
      };

      // Get all data for current tab (irrespective of pagination)
      let allData = [];
      let headers = [];
      let fileName = "";

      switch (selectedTab) {
        case 0: // Abbreviations
          allData = abbreviations || [];
          headers = ["Abbreviation", "Replace Word", "Created By"];
          fileName = "Abbreviations";
          break;
        case 1: // Aliases
          allData = aliases || [];
          headers = ["Name", "Alias Name", "Alias Type", "Created By"];
          fileName = "NameAliases";
          break;
        case 2: // Anglicized
          allData = anglicized || [];
          headers = ["Name", "Anglicized Name", "Created By"];
          fileName = "AnglicizedWords";
          break;
        case 3: // Bad Data
          allData = badData || [];
          headers = ["Special Char", "Created By"];
          fileName = "BadData";
          break;
        case 4: // Double letters
          allData = doubleLetters || [];
          headers = ["Letter", "Replace Letter", "Created By"];
          fileName = "DoubleLetters";
          break;
        case 5: // Initials
          allData = initials || [];
          headers = ["Name", "Initial", "Created By"];
          fileName = "Initials";
          break;
        case 6: // Nicknames
          allData = nicknames || [];
          headers = ["Name", "Nick Name", "Created By"];
          fileName = "NickName";
          break;
        case 7: // Intervening
          allData = intervining || [];
          headers = ["Intervening Words", "Created By"];
          fileName = "InterveningWords";
          break;
        case 8: // Countries
          allData = countries || [];
          headers = ["Country Name", "Created By"];
          fileName = "Countries";
          break;
        default:
          Swal.close();
          Swal.fire({
            icon: "warning",
            text: "Export not available for this tab.",
            showConfirmButton: false,
            timer: 3000,
          });
          return;
      }

      if (!allData || allData.length === 0) {
        Swal.close();
        Swal.fire({
          icon: "info",
          text: "No data available to export.",
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }

      // Map data to CSV rows based on tab
      const rows = allData.map((row) => {
        switch (selectedTab) {
          case 0: // Abbreviations
            return [
              row.name || "",
              row.abbreviations || "",
              row.created_by || "",
            ];
          case 1: // Aliases
            return [row.name || "", row.alias_word || "", row.created_by || ""];
          case 2: // Anglicized
            return [
              row.entity_name || "",
              row.anglicized_word || "",
              row.created_by || "",
            ];
          case 3: // Bad Data
            return [row.special_char || "", row.created_by || ""];
          case 4: // Double letters
            return [
              row.letter || "",
              row.replace_letter || "",
              row.created_by || "",
            ];
          case 5: // Initials
            return [row.name || "", row.initial || "", row.created_by || ""];
          case 6: // Nicknames
            return [row.name || "", row.nick_name || "", row.created_by || ""];
          case 7: // Intervening
            return [row.word_list || "", row.created_by || ""];
          case 8: // Countries
            return [row.country || "", row.created_by || ""];
          default:
            return [];
        }
      });

      // Build CSV content with proper escaping
      const csvLines = [
        headers.map(csvEscape).join(","),
        ...rows.map((r) => r.map(csvEscape).join(",")),
      ];

      // Add UTF-8 BOM for Excel compatibility and use \r\n for line breaks
      const csvContent = "\uFEFF" + csvLines.join("\r\n");

      // Create and download the CSV file
      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);

      // Generate filename with date in DDMMYY format
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yy = String(today.getFullYear()).slice(-2);
      const dateStr = `${dd}${mm}${yy}`;

      link.setAttribute("download", `${fileName}_${dateStr}.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      Swal.close();
      Swal.fire({
        icon: "success",
        text: `Successfully exported ${allData.length} record(s)!`,
        showConfirmButton: false,
        timer: 3000,
      });
    } catch (error) {
      console.error("Error exporting data:", error);
      Swal.close();
      Swal.fire({
        icon: "error",
        text: "An error occurred while exporting data.",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  // Determine whether to show the "Delete All" button for the current tab
  // Only show when at least one of the `selectedRows` for this tab exists
  const allIdsForCurrentTab = (() => {
    switch (selectedTab) {
      case 0:
        return (abbreviations || []).map((r) => r.record_id);
      case 1:
        return (aliases || []).map((r) => r.record_id);
      case 2:
        return (anglicized || []).map((r) => r.record_id);
      case 3:
        return (badData || []).map((r) => r.record_id);
      case 4:
        return (doubleLetters || []).map((r) => r.record_id);
      case 5:
        return (initials || []).map((r) => r.record_id);
      case 6:
        return (nicknames || []).map((r) => r.record_id);
      case 7:
        return (intervining || []).map((r) => r.record_id);
      case 8:
        return (countries || []).map((r) => r.record_id);
      default:
        return [];
    }
  })();

  const showDeleteButton = (() => {
    const sel = getSelectedRowsForTab(selectedTab);
    return (
      Array.isArray(sel) &&
      sel.length > 0 &&
      sel.some((id) => allIdsForCurrentTab.includes(id))
    );
  })();

  // helper to get filtered count for the current tab
  const getFilteredLengthForTab = (tab) => {
    switch (tab) {
      case 0:
        return filteredData(0, abbreviations).length;
      case 1:
        return filteredData(1, aliases).length;
      case 2:
        return filteredData(2, anglicized).length;
      case 3:
        return filteredData(3, badData).length;
      case 4:
        return filteredData(4, doubleLetters).length;
      case 5:
        return filteredData(5, initials).length;
      case 6:
        return filteredData(6, nicknames).length;
      case 7:
        return filteredData(7, intervining).length;
      case 8:
        return filteredData(8, countries).length;
      default:
        return 0;
    }
  };

  const totalPagesForCurrentTab = Math.max(
    1,
    Math.ceil(getFilteredLengthForTab(selectedTab) / itemsPerPage)
  );

  return (
    <div className="efficiency-page">
      <div className="page-container">
        <ReferenceTabs
          selectedTab={selectedTab}
          handleTabChange={handleTabChange}
          tabsData={tabsData}
        />
        {selectedTab !== 9 && (
          <div
            className="refdata-toolbar"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "#ededed",
              padding: "16px 0",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              {/* {selectedTab !== 8 && ( */}
              <a
                href="#"
                style={{ color: "#0099c9", textDecoration: "underline" }}
                onClick={(e) => {
                  e.preventDefault();
                  handleSummaryModal();
                }}
              >
                View History
              </a>
              {/* )} */}
              <SearchBox searchTerm={searchTerm} handleSearch={handleSearch} />
            </div>
            <div className="d-flex align-items-center">
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={submit}
                accept=".csv"
                onClick={(e) => {
                  e.target.value = null; // Reset file input value
                }}
              />
              <button
                className="btn createButton me-3"
                title="Upload File"
                onClick={() => fileInputRef.current?.click()}
              >
                <MdCloudUpload size={22} />
              </button>
              <button
                className="btn createButton me-3"
                title="Create"
                onClick={handleCreateClick}
              >
                <MdCreateNewFolder size={22} />
              </button>
              <button
                className="btn createButton "
                title="Export Data"
                onClick={handleExportData}
              >
                <MdCloudDownload size={22} />
              </button>
              {showDeleteButton && (
                <button
                  className="btn createButton ms-3"
                  title="Delete"
                  onClick={handleBulkDelete}
                >
                  <MdDelete size={22} />
                </button>
              )}
            </div>
          </div>
        )}

        {/* Abbreviations Module */}
        {selectedTab === 0 && (
          <AbbreviationsTab
            searchTerm={searchTerm}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handleEditClick={(row) => {
              setEditFormData(row);
              setEditModalOpen(true);
            }}
            data={filteredData(0, abbreviations)}
            handleDeleteClick={handleDeleteClick}
            exactSearch={searchTerm}
            selectedRows={getSelectedRowsForTab(0)}
            setSelectedRows={(v) => setSelectedRowsForTab(0, v)}
          />
        )}
        {/* Aliases Module */}
        {selectedTab === 1 && (
          <AliasesTab
            searchTerm={searchTerm}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handleEditClick={(row) => {
              setEditFormData(row);
              setEditModalOpen(true);
            }}
            data={filteredData(1, aliases)}
            handleDeleteClick={handleDeleteClick}
            exactSearch={searchTerm}
            selectedRows={getSelectedRowsForTab(1)}
            setSelectedRows={(v) => setSelectedRowsForTab(1, v)}
          />
        )}
        {/* Anglicized Module */}
        {selectedTab === 2 && (
          <AnglicizedTab
            searchTerm={searchTerm}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handleEditClick={(row) => {
              setEditFormData(row);
              setEditModalOpen(true);
            }}
            data={filteredData(2, anglicized)}
            handleDeleteClick={handleDeleteClick}
            // handleSearch={handleSearch}
            exactSearch={searchTerm}
            selectedRows={getSelectedRowsForTab(2)}
            setSelectedRows={(v) => setSelectedRowsForTab(2, v)}
          />
        )}
        {/* BadData Module */}
        {selectedTab === 3 && (
          <BadDataTab
            searchTerm={searchTerm}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handleEditClick={(row) => {
              setEditFormData(row);
              setEditModalOpen(true);
            }}
            data={filteredData(3, badData)}
            handleDeleteClick={handleDeleteClick}
            exactSearch={searchTerm}
            selectedRows={getSelectedRowsForTab(3)}
            setSelectedRows={(v) => setSelectedRowsForTab(3, v)}
          />
        )}
        {/* DoubleLetters Module */}
        {selectedTab === 4 && (
          <DoubleLettersTab
            searchTerm={searchTerm}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handleEditClick={(row) => {
              setEditFormData(row);
              setEditModalOpen(true);
            }}
            data={filteredData(4, doubleLetters)}
            handleDeleteClick={handleDeleteClick}
            handleSearch={handleSearch}
            exactSearch={searchTerm}
            selectedRows={getSelectedRowsForTab(4)}
            setSelectedRows={(v) => setSelectedRowsForTab(4, v)}
          />
        )}
        {/* Initials Module */}
        {selectedTab === 5 && (
          <InitialsTab
            searchTerm={searchTerm}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handleEditClick={(row) => {
              setEditFormData(row);
              setEditModalOpen(true);
            }}
            data={filteredData(5, initials)}
            handleDeleteClick={handleDeleteClick}
            handleSearch={handleSearch}
            exactSearch={searchTerm}
            selectedRows={getSelectedRowsForTab(5)}
            setSelectedRows={(v) => setSelectedRowsForTab(5, v)}
          />
        )}
        {/* Nicknames Module */}
        {selectedTab === 6 && (
          <NicknamesTab
            searchTerm={searchTerm}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handleEditClick={(row) => {
              setEditFormData(row);
              setEditModalOpen(true);
            }}
            data={filteredData(6, nicknames)}
            handleDeleteClick={handleDeleteClick}
            handleSearch={handleSearch}
            exactSearch={searchTerm}
            selectedRows={getSelectedRowsForTab(6)}
            setSelectedRows={(v) => setSelectedRowsForTab(6, v)}
          />
        )}
        {/* Intervening Module */}
        {selectedTab === 7 && (
          <InterveningTab
            searchTerm={searchTerm}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handleEditClick={(row) => {
              setEditFormData(row);
              setEditModalOpen(true);
            }}
            data={filteredData(7, intervining)}
            handleDeleteClick={handleDeleteClick}
            handleSearch={handleSearch}
            exactSearch={searchTerm}
            selectedRows={getSelectedRowsForTab(7)}
            setSelectedRows={(v) => setSelectedRowsForTab(7, v)}
          />
        )}
        {/* Countries Module */}
        {selectedTab === 8 && (
          <CountriesTab
            searchTerm={searchTerm}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handleEditClick={(row) => {
              setEditFormData(row);
              setEditModalOpen(true);
            }}
            data={filteredData(8, countries)}
            handleDeleteClick={handleDeleteClick}
            exactSearch={searchTerm}
            selectedRows={getSelectedRowsForTab(8)}
            setSelectedRows={(v) => setSelectedRowsForTab(8, v)}
          />
          //           <CountriesTab
          //   searchTerm={searchTerm}
          //   currentPage={currentPage}
          //   itemsPerPage={itemsPerPage}
          //   handleEditClick={(row) => {
          //     setEditFormData(row);
          //     setEditModalOpen(true);
          //   }}
          //   data={filteredData(8, countries)}
          //   handleDeleteClick={handleDeleteClick}
          //   exactSearch={searchTerm}
          // />
        )}
        {/* MT202 Module */}
        {selectedTab === 9 && (
          <MT202Tab
            mt202Files={[]}
            setMt202Files={() => {}}
            mt202ImportModal={false}
            setMt202ImportModal={() => {}}
            mt202File={null}
            setMt202File={() => {}}
            mt202Generate={false}
            setMt202Generate={() => {}}
            mt202Apply={false}
            setMt202Apply={() => {}}
            mt202ViewRow={null}
            setMt202ViewRow={() => {}}
            searchTerm={searchTerm}
            handleSearch={handleSearch}
            handleDeleteClick={handleDeleteClick}
            previewTableData={[]}
            indexOfFirstItem={0}
            handleMt202Import={() => {}}
            handleMt202FileChange={() => {}}
            handleMt202Submit={() => {}}
            handleMt202Generate={() => {}}
          />
        )}
        {/* Table Pagination */}
        {selectedTab !== 9 && getFilteredLengthForTab(selectedTab) > 0 && (
          <>
            <TablePagination
              currentPage={currentPage}
              totalPages={totalPagesForCurrentTab}
              handleFirstPage={() => setCurrentPage(1)}
              handlePrevPage={() =>
                setCurrentPage((prev) => Math.max(prev - 1, 1))
              }
              handleNextPage={() =>
                setCurrentPage((prev) =>
                  prev < totalPagesForCurrentTab ? prev + 1 : prev
                )
              }
              handleLastPage={() => setCurrentPage(totalPagesForCurrentTab)}
            />
          </>
        )}
        {selectedTab !== 9 && (
          <ViewHistoryModal
            open={summaryModal}
            onClose={handleSummaryModal}
            currentPage={modalCurrentPage}
            setCurrentPage={setModalCurrentPage}
            selectedTab={selectedTab}
          />
        )}
        {/* This is for creating new records */}
        <CreateModal
          open={createModalOpen}
          onClose={() => setCreateModalOpen(false)}
          selectedTab={selectedTab}
          createFormData={createFormData}
          handleCreateFormChange={handleCreateFormChange}
          handleCreateSubmit={handleCreateSubmit}
          resetCreateForm={resetCreateForm}
        />

        {/* This is for editing existing records */}
        <EditModal
          open={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          selectedTab={selectedTab}
          recordId={editFormData.record_id}
          handleEditSubmit={handleEditSubmit}
        />
      </div>
    </div>
  );
}

export default ReferenceData;
